const allowedRedirectUrls = ["/", "/checkout/"];

export function isValidRedirectUrl(url: string) {
    // Check if not null or undefined
    if (!url) return false;

    try {
        const parsedUrl = new URL(url, window.location.origin);

        // Disable this when in development mode as npm run dev uses http
        if (import.meta.env.MODE !== "development") {
            // Check if protocol is safe (https)
            if (parsedUrl.protocol !== "https:") {
                console.warn("isValidRedirectUrl(): Invalid protocol:", parsedUrl.protocol);
                return false;
            }
        }

        // Basic hostname check (must match current origin).
        if (parsedUrl.hostname !== window.location.hostname) {
            console.warn("isValidRedirectUrl(): Invalid hostname:", parsedUrl.hostname);
            return false;
        }

        // Check if pathname is allowed
        if (!allowedRedirectUrls.includes(parsedUrl.pathname)) {
            console.warn("isValidRedirectUrl(): Invalid pathname:", parsedUrl.pathname);
            return false;
        }

        return true;
    } catch (error) {
        console.error("isValidRedirectUrl(): Invalid URL format:", error);
        return false;
    }
}
